export const ENV_KEY = {
  LIFF_ID: 'LIFF_ID',
  BASE_URL: 'BASE_URL',
  SHOP_ID: 'SHOP_ID',
  CLIENT_ID: 'CLIENT_ID',
  LINE_BOT_ID: 'LINE_BOT_ID',
  IMAGE_API: 'IMAGE_API',
  GTM_ID: 'GTM_ID',
  GMO_ID: 'GMO_SHOP_ID',
  AMAZON_PAY_CLIENT_API: 'AMAZON_PAY_CLIENT_API',
  AMAZON_PAY_MERCHANT_ID: 'AMAZON_PAY_MERCHANT_ID',
  AMAZON_PAY_PUBLIC_KEY: 'AMAZON_PAY_PUBLIC_KEY',
}
